class ProductGallery {
  constructor(container) {
    this.container = container;

    this.slides = [...container.querySelectorAll('[data-gallery-slide]')];
    this.thumbnails = [...container.querySelectorAll('[data-thumbnail]')];

    this.prevButton = container.querySelector('[data-gallery-prev]');
    this.nextButton = container.querySelector('[data-gallery-next]');

    this.currentIndex = this.slides.findIndex((slide) =>
      slide.classList.contains('is-active')
    );

    if (this.currentIndex < 0) {
      this.currentIndex = 0;
    }

    this.init();
  }

  init() {
    this.bindThumbnailClicks();
    this.bindArrows();

    this.update();
  }

  bindThumbnailClicks() {
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => {
        this.currentIndex = index;
        this.update();
      });
    });
  }

  bindArrows() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.goToPrevious();
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.goToNext();
      });
    }
  }

  goToPrevious() {
    this.currentIndex--;

    if (this.currentIndex < 0) {
      this.currentIndex = this.slides.length - 1;
    }

    this.update();
  }

  goToNext() {
    this.currentIndex++;

    if (this.currentIndex >= this.slides.length) {
      this.currentIndex = 0;
    }

    this.update();
  }

  update() {
    this.slides.forEach((slide, index) => {
      slide.classList.toggle(
        'is-active',
        index === this.currentIndex
      );
    });

    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.classList.toggle(
        'is-active',
        index === this.currentIndex
      );
    });
  }
}

/* =========================================================
   INIT
========================================================= */

document.addEventListener('DOMContentLoaded', () => {

  const galleries = document.querySelectorAll('[data-product-gallery]');

  galleries.forEach((gallery) => {
    new ProductGallery(gallery);
  });

});